import api from '@/services/api'
import { downloadCsvFile, escapeCsvCell } from '@/utils/warehouseTableHelpers'

export type PurchasingSheetExportResponse = {
  spreadsheet_id: string
  url: string
  name: string
}

/** Generic table export via the purchasing sheet endpoint (headers + rows). */
export async function exportPurchasingTableToGoogleSheet(
  title: string,
  headers: string[],
  rows: string[][],
): Promise<PurchasingSheetExportResponse> {
  const { data } = await api.post<PurchasingSheetExportResponse>('/purchasing/export-sheet', {
    title,
    headers,
    rows,
  })
  return data
}

export function exportPurchasingTableCsv(filename: string, headers: string[], rows: string[][]): void {
  const csvRows = rows.map((row) => row.map((cell) => escapeCsvCell(cell)).join(','))
  downloadCsvFile(filename, [headers.join(','), ...csvRows].join('\n'))
}
